import { combineReducers } from "redux";
import PersonalReducer from "../Components/PersonalInfo/redux/PersonalReducer";
import IncomeReducer from "../Components/IncomeDetails/redux/incomeReducer";
import EducationReducer from "../Components/Education/redux/eduReducer";
import RegistrationReducer from "../Components/Register/redux/RegistrationReducer";
import tokenReducer from "../Components/LoginPage/redux/TokenReducer";
import ApplicationReducer from "../Components/ApplicationForm/redux/applicationReducer";
import queryReducer from "../Components/Queries/redux/QueryReducer";
import StatusReducer from "../Components/WelcomeBack/redux/StatusReducer";
import DispurseReducer from "../Components/DisburseForm/redux/dispurseReducer";
import TimerReducer from "../Components/IdfcLetterHead/redux/timerReducer";
import ConnectReducer from "../Components/Connect/redux/connectReducer";

const rootReducer = combineReducers({
  // page: pageReducer,
  personal: PersonalReducer,
  income:IncomeReducer,
  education:EducationReducer,
  register:RegistrationReducer,
  tokens:tokenReducer,
  application:ApplicationReducer,
  queries:queryReducer,
  status:StatusReducer,
  spoc:DispurseReducer,
  connect:ConnectReducer,
  timer:TimerReducer



});

export default rootReducer;
